import customAxios from "../serverCall";

const getProductCategories = async (body) => {
  const response = await customAxios.post(`/admin/product-categories/list`, body);
  return response;
};

const createProductCategory = async (body) => {
  const response = await customAxios.post(`/admin/product-categories`, body);
  return response;
};

const updateProductCategory = async (body) => {
  const response = await customAxios.post(`/admin/product-categories/update`, body);
  return response;
};

const ProductCategoriesService = {
  getProductCategories,
  createProductCategory,
  updateProductCategory,
};

export default ProductCategoriesService; 